import RulesMixin from "@/assets/plugins/mps-common/rules/RulesMixin";

export default {

    install(Vue) {
        Vue.mixin(RulesMixin);
    }

}